import './styles.scss'

import React from 'react'
import { useSelector } from 'react-redux'
import ReactSelect, { components } from 'react-select'
import Tooltip from 'rc-tooltip'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import railsContext from 'lib/selectors/rails-context'

const customStyles = {
  option: provided => ({
    ...provided,
    padding: 5
  }),
  control: (provided, { isFocused }) => ({
    width: '254px',
    height: '10px',
    border: '1px solid #bbb',
    fontSize: '13px',
    minHeight: isFocused ? '30px' : '30px',
    display: isFocused ? 'inline-flex' : 'inline-flex'
  }),
  menu: provided => ({
    ...provided,
    marginTop: 2,
    width: '254px',
    paddingTop: '0',
    paddingBottom: '0'
  }),
  menuList: provided => ({
    ...provided,
    paddingTop: '0',
    paddingBottom: '0'
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none'
  })
}

const { Option } = components

const CustomOption = props => (
  <Option {...props}>
    <Tooltip trigger={['hover']} placement='right' overlay={props.data.label} mouseEnterDelay={0.5}>
      <div className='ellipsis'>
        <span>{props.children}</span>
      </div>
    </Tooltip>
  </Option>
)

const TimeZonePicker = ({ timezone, onChange }) => {
  const { timezoneNames } = useSelector(railsContext)

  return (
    <div data-attr='timezone-select'>
      <ReactSelect
        components={{ Option: CustomOption }}
        value={timezoneNames.filter(option => option.value === timezone)}
        isSearchable
        options={timezoneNames}
        placeholder={I18n.t('timezone.placeholder')}
        onChange={option => onChange(option.value)}
        className='react-select-container'
        classNamePrefix='react-select'
        noOptionsMessage={() => I18n.t('timezone.no_options')}
        styles={customStyles}
        theme={theme => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: 'rgba(142, 202, 16, 0.2)',
            primary: '#8eca10'
          }
        })}
      />
    </div>
  )
}

CustomOption.propTypes = {
  data: PropTypes.object,
  children: PropTypes.node
}

TimeZonePicker.propTypes = {
  timezone: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

export default TimeZonePicker
